function LoadingPage() {
  return (
    <main>
      <div className="container">
        <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
          <div className="row">
            <div className="col-lg-12">
              <span className="spinner-grow text-danger " role="status"></span>
              &nbsp;&nbsp;
              <span className="spinner-grow text-danger " role="status"></span>
              &nbsp;&nbsp;
              <span className="spinner-grow text-danger " role="status"></span>
              &nbsp;&nbsp;
            </div>
          </div>
          <div className="credits"></div>
        </section>
      </div>
    </main>
  );
}

export default LoadingPage;
